<template>
    <div class="order-grid col-sm-12 col-md-12 col-lg-12">
        <h1 class="top-title"> Nurses Assigned to Patient</h1>
        <div class="header2">
            
          <!--  <button class="btn btn-dark" type="button" @click="showAddProv">
                Nurse Settings
            </button>
            <button  class="btn btn-primary" type="button" @click="showNurseForm">
                Add Nurse
            </button>
            <button class="btn btn-success" type="button" id="verifybtn" @click="VerifyAllNurses">
                Verify All Nurses
            </button>-->
        </div>
        <!--<div class="col-sm-12 col-md-12 col-lg-12 addNurseSec">
            <form id="nurseform">
                <div class="container form-container">
                    <div class="msgbx">

                    </div>
                    <label for="nursetype">Nurse Type:</label>
                    <select class="field" id="nursetype" aria-placeholder="*Required">
                        <option select="selected" value="Select Nurse Type">Select Nurse Type</option>
                        <option value="RN">Registred Nurse</option>
                        <option value="LPN">Licensed Practical Nurse</option>
                        <option value="CN">Cardic Nurse</option>
                        <option value="CRNA">Certified Registered Nurse Anesthetist</option>
                    </select>
                    <label for="nursefname">First Name:</label>
                    <input  type="text" id="nursefname" placeholder="*Required" value="" class="field"/>
                    <label for="nurselname">Last Name:</label>
                    <input  type="text" id="nurselname" value="" placeholder="*Required" class="field"/>
                    <label for="nurseemail">Email:</label>
                    <input type="email" id="nurseemail" value="" placeholder="*Required" class="field"/>
                    <label for="primephone">Primary Phone:</label>
                    <input type="phone" id="primephone" value=""  class="field"/>
                    <label for="secphone">Secondary Phone:</label>
                    <input type="phone" id="secphone" value=""  class="field"/>
                    <label for="nrlicense">License Number:</label>
                    <input  type="text" id="nrlicense" value="" placeholder="*Required" class="field"/>
                    <label for="nrsocial">Social Security:</label>
                    <input  type="text" id="nrsocial" value="" placeholder="*Required" class="field"/>
                    <label for="nrdob">Date of Birth:</label>
                    <input  type="text" id="nrdob" value="" placeholder="*Required" class="field"/>
                    <label for="nraddress">Address:</label>
                    <input type="text" id="nraddress" value="" class="field"/>
                    <label for="nrcity">City:</label>
                    <input type="text" id="nrcity" value="" class="field"/>
                    <label for="nrstate">State:</label>
                    <input type="text" id="nrstate" value="" class="field"/>
                    <label for="nrzip">Zip:</label>
                    <input type="text" id="nrzip" value="" class="field"/>
                    <label for="nraccount">Account Number:</label>
                    <input  type="text" id="nraccount" value="" placeholder="*Required" class="field"/>
                    <label for="nrnsbid">NBSID Number:</label>
                    <input type="text" id="nrnsbid" value="" class="field"/>
                    <div class="nurseform-btn">
                        <input type="button" class="btn btn-primary" value="Add Nurse" id="addnursebtn" @click="addNurse($event)"/>
                        <input type="button" class="btn btn-secondary" value="Close" id="addnursebtn" @click="CloseaddNurse($event)"/>
                    </div>
                    
                </div>
            </form>
            
           
            
        </div>-->
       <!---- <div class="col-sm-12 col-md-12 col-lg-12 nurseSettingSec">
            <div class="container setting-container">
                <form>
                    <div class="horizontal col-sm-12 col-md-12 col-lg-12">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <label>Verify Nurses Frequency:</label>
                            <select class="selectfield" id="checkWhen">
                                <option selected="selected" value="selected">Select Verification Frequency</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Bi-weekly">Bi-weekly</option>
                                <option value="monthly">Once a Month</option>
                                <option value="yearly">Yearly</option>
                            </select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6">
                             <label>Notify License Expiration:</label>
                            <select class="selectfield" id="notifyexpirationdt">
                                <option selected="selected" value="selected">Select Notice of Expireation</option>
                                <option  value="oneweek">1 Week Before</option>
                                <option value="twoweek">2 Weeks Before</option>
                                <option value="monthbefore">1 Month Before</option>
                                <option value="twomonth">2 Month Before</option>
                            </select>
                        </div>
                    </div>
                    <div class="horizontal col-sm-12 col-md-12 col-lg-12">
                        <div class="h-vertical col-sm-12 col-md-6 col-lg-6">
                            <label>Notification Type:</label>
                            <select class="selectfield" id="notifytype">
                                <option selected="selected" value="Weekly">Select Notification Type</option>
                                <option  value="sms">SMS</option>
                                <option value="Email">Email</option>
                                <option value="Phone">Phone Call</option>
                                <option value="bothsmsnemail">Email & SMS</option>
                                
                            </select>
                        </div>
                        <div clas="h-vertical col-sm-12 col-md-6 col-lg-6">
                            <label>Nurses Communication Features:</label>
                            <select class="selectfield" id="nursecomfeat">
                                <option selected="selected" value="alloff">All Communication Features Off (View Nurses Info Only)</option>
                                <option value="allon">All Communication Features On (SMS, Call, Email)</option>
                                <option value="emailfeatureonly">Email Only (No Text)</option>
                                <option value="textonly">SMS only</option>
                                
                            </select>
                        </div>
                    </div>
                        
                       
                   
                    <div class="horizontal col-sm-12 col-md-12 col-lg-12">
                        <button class="btn btn-primary" id="savesettingbtn" @click="SaveSettings($event)">Save Settings</button>
                        <button class="btn btn-secondary" id="savesettingbtn" @click="CancelSettings($event)">Close</button>
                    </div>
                </form>
            </div>
        </div>-->
        <div class="col-sm-12 col-md-12 col-lg-12 listGroupSec" >
            <div class="card" v-for="(group,index) in groupNumber" :key="'grplist'+index">
			<div class="accordhead">
		  	 <div class="caret">
		  	 <span @click="ShowGroupList(index)" id="accord-caret">+</span>
		  	 <div class="elipsecontainer">
		  	 <div id="elipse"  @click="ShowSubNav(index)">...</div>
		  	 <div class="subnavcontainer" :id="'subnav'+index" >
		  	 <div class="sub-nav"><a href='#email' :id="'mergeemail'+index" @click="SendGroupEmail(index)">Send Group Email </a></div>
		  	 <div class="sub-nav"><a href='#textsms' :id="'mergetext'+index" @click="SendGroupText(index)">Send Group SMS</a></div>
		  	  <div class="sub-nav"><a href="#conftextsms" :id="'mergeconftext'+index" @click="GroupConferenceCall(index)">Conference Call SMS Group</a></div>
		  	 <div class="sub-nav"><a href="#deletegrp" :id="'deletegrp'+index" @click="DeleteGroup(index)">Delete Group</a></div>
		  	 </div>
		  	 </div>
		  	 </div>
		  	 <div class="grp-name"><p :key="index" id="gpname">{{group.groupname}}</p></div>
		  	 </div>

             
                
		  	 <div class='accordionbottom' :id="'accordionbottom'+index">
                    <div  v-for="(provlist, index) in group.providerslist" :key="'provlist'+index" :id="'provminicard'+index" class='providminicard col-sm-12 col-md-12 col-lg-12'>
                    <div class='col-sm-12 col-md-3 col-lg-3'>
                    <p id='grprovemail'>{{provlist.email}}</p>
                    </div>
                    <div class='col-sm-12 col-md-3 col-lg-3'>
                    <p>{{provlist.firstname}} {{provlist.lastname}}</p>
                    </div>
                    <div class='col-sm-12 col-md-3 col-lg-3'>
                    <p id='grpnpi'>{{provlist.npi}}</p>
                    </div>
                    <div class='col-sm-12 col-md-3 col-lg-3'>
                    <p id='grpphn'>{{provlist.phone}}</p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="smsconferencecanvas">
                    <div class="container">
                        <form id="smsform">
                            <label>To:</label><input type="text" required="required" id="smsconferencephone"/><br/>
                            <textarea id="smsconferencebox" placeholder="Enter Text Message..">

                            </textarea><br/>
                            <input type="button" class="btn btn-danger" value="Send Text Message" id="sbmttxtconfbtn" @click="SendGroupTextMsg"/>
                            <input type="button" class="btn btn-danger conf-call-btn" value="Send Conference Call" id="confcallbtn" @click="SendGroupConferenceCall"/>
                            <input type="button" class="btn btn-dark" value="Exit & Close" id="closeconfcallbtn" @click="CloseGroupConferenceCall"/>

                        </form>
                    </div>
                                      
                </div>
                <div class="groupemailcecanvas">
                    <div class="container">
                        <form id="emailform">
                            <label>To:</label><input type="text" required="required" id="conferenceEmail"/><br/>
                            <textarea id="emailconferencebox" placeholder="Enter Email Message">

                            </textarea><br/>
                            <input type="button" class="btn btn-danger" value="Send Group Email" id="sbmtemailconfbtn" @click="SendGroupEmailMsg"/>
                            <input type="button" class="btn btn-dark" value="Cancel" id="groupemailcancelbtn" @click="CloseGroupEmailMsg"/>
                        </form>
                    </div>
                                      
                </div>
        
        <div class="new-prov-modal" :id="'provmodal' + patient.id">
            <form :id="'provform' + patient.id" @submit.prevent="saveProv">
                <div class="form-group">
                    <label for="primphysician">Physician Name Lookup</label>
                    <input name="primphysician" type="text" id="primphysician" class="form-control" v-model="npiSearch"
                        @keyup.prevent="showResults" />
                    <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                        <div v-for="(npi, index) in searchedNpis" class="additionalnameli"
                            :key="index + 'npi' + npi.npinumber" @click="selectNpi(npi)">
                            {{ npi.name }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phyfirstname">First Name</label>
                    <input name="phyfirstname" type="text" required id="phyfirstname" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phylastname">Last Name</label>
                    <input name="phylastname" type="text" required id="phylastname" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phynpi">NPI</label>
                    <input name="phynpi" type="text" id="phynpi" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phyaddr">Address</label>
                    <input name="phyaddr" type="text" id="phyaddr" class="form-control" />
                    <div v-if="searchedAddresses" id="npiadditionaladdr" class="npiadditionaladdr">
                        <div v-for="(addr, index) in searchedAddresses" @click="selectAddr(addr)" class="additonaladdrli"
                            :key="index">
                            {{ addr.address }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phytel">Tel</label>
                    <input name="phytel" type="text" id="phytel" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phycell">Cell</label>
                    <input name="phycell" type="text" id="phycell" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phyfax">Fax</label>
                    <input name="phyfax" type="text" id="phyfax" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="phytel">Email</label>
                    <input name="phyemail" type="text" id="phyemail" class="form-control" />
                </div>
                <div class="btn-group">
                    <button type="submit" class="btn btn-primary">Save</button>
                    <button type="button" class="btn btn-secondary" @click="closeProv">Cancel</button>
                </div>
            </form>
        </div>
    <!--<div v-if="editedProv" :id="'edit-prov-modal-' + patient.id" class="edit-prov-modal">
                <form :id="'edit-prov-form-' + patient.id" @submit.prevent="saveEditProv">
                    <div class="form-group">
                        <label for="phy-firstname">First Name</label>
                        <input name="phyfirstname" type="text" required :value="editedProv.firstname" id="phy-firstname"
                            class="form-control" />
                    </div>
                    <div class="form-group">
                        <label for="phy-lastname">Last Name</label>
                        <input name="phylastname" type="text" required :value="editedProv.lastname" id="phy-lastname"
                            class="form-control" />
                    </div>
                    <div class="form-group">
                        <label for="phy-npi">NPI</label>
                        <input name="phynpi" type="text" id="phy-npi" class="form-control" :value="editedProv.npinumber" />
                    </div>
                    <div class="form-group">
                        <label for="phy-addr">Address</label>
                        <input name="phyaddr" type="text" id="phy-addr" class="form-control" :value="editedProv.addr1" />
                    </div>
                    <div class="form-group">
                        <label for="phy-tel">Tel</label>
                        <input name="phytel" type="text" id="phy-tel" class="form-control" :value="editedProv.tel" />
                    </div>
                    <div class="form-group">
                        <label for="phy-cell">Cell</label>
                        <input name="phycell" type="text" id="phy-cell" class="form-control" :value="editedProv.cell" />
                    </div>
                    <div class="form-group">
                        <label for="phy-fax">Fax</label>
                        <input name="phyfax" type="text" id="phy-fax" class="form-control" :value="editedProv.fax" />
                    </div>
                    <div class="form-group">
                        <label for="phy-tel">Email</label>
                        <input name="phyemail" type="text" id="phy-email" class="form-control" :value="editedProv.email" />
                    </div>
                    <div class="btn-group">
                        <button type="submit" class="btn btn-primary">Save</button>
                        <button type="button" class="btn btn-secondary" @click="closeEditProv">Cancel</button>
                    </div>
                </form>
            </div>-->
        <div :id="'send-text-modal-' + patient.id" class="send-text-modal" :style="{ 'display': 'none' }">
            <div class="inner-text-modal">
                <div class="form-group">
                    <label>Cell Number:</label>
                    <input type="text" required  :id="'modaltext'+patient.id"  class="form-control prvtxtbox" /><br/>
                    <label>Enter text body</label>
                    <input type="text" required  :id="'modalmsg'+patient.id" class="form-control prvtxtMsgbox" />
                </div>
                <div class="btn-group">
                    <button type="submit" class="btn btn-primary" @click="sendText(patient.id)">Send</button>
                    <button type="button" class="btn btn-secondary" @click="closeText">Cancel</button>
                </div>
            </div>
        </div>
        
        
        <ul v-if="allProvs" class="result-list">
            <li v-for="(provider, index) in allProvs" :key="index">
                <div class="result-item" :id="'ncard'+provider.licensenum">
                    <h2 class="header3 capitalize">
                        <span v-if="provider.firstname">{{ provider.firstname.toLowerCase() }} </span>
                        <span v-if="provider.lastname">{{ provider.lastname.toLowerCase() }}</span>
                        <div class="modifier-container">
                            <button class="modifier-indicator" @click="showMod(index)">...</button>
                            <div class="modifier-dropdown" :id="'modifier-dropdown' + index">
                                <button class="provbtn edit" @click="showEditProv(provider.licensenum)">Edit</button>
                                <button class="provbtn remove" @click="dischargeProvider(patient.externId2,patient.externId,provider.nurseid,provider.firstname,provider.lastname)">Discharge</button>
                               <!-- <button class="provbtn call" @click="callProvider(provider)">Call</button>
                                <button class="provbtn txt" @click="showTextProv(provider)">Text</button>
                                <button class="provbtn email" @click.self="showEmailModule($event,index,provider)">Email</button>-->
                            </div>
                        </div>
                    </h2>
                    <div class="col-sm-12 col-md-12 col-lg-12 status-nonactive" :id="'vstatus'+provider.licensenum">
                        <p>License Status Not Active</p>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12 status-active" :id="'vstatus2'+provider.licensenum">
                        <p>License Status Active</p>
                    </div>
                    <!-- TODO: is it a good idea to pick the first entry?  -->
                    <!-- <provider-bio :provider="provider" :specialty="provider.specialties[0].name" :keywords="keywords"></provider-bio> -->
                    <div class="emailcanvas" :id="'emailcanvas'+provider.providerid">
                        <div class="container">

                            <label>Email:<span id="cllprov">Joseph Mulvehill</span></label><br/>
                            <!--<label>To:</label><input type="text" id="providetomail" class="provid-inputfield"/><br/>-->
                            <label>To:</label><input type="text" :id="'providetomail'+provider.providerid" class="provid-inputfield">
                            <div class="inputvalholder">
                                <!--<li class="emailli">
                                    <div class="emailblock">
                                        <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">keyon5052@gmail.com</a>
                                        <span class="xout">X</span>
                                    </div>
                                </li>
                                <li class="emailli">
                                    <div class="emailblock">
                                        <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">emailvip52@gmail.com</a>
                                        <span class="xout">X</span>
                                    </div>
                                </li>-->
                            </div>
                            <ul class="selectbox">
                                <!--<li class="emailbox">
                                    <p id="selectemailp">Keyon@gmail.com</p>
                                    <div id="hiddenmail"></div>
                                </li>-->
                            </ul>
                            <br/>
                            <label>Subject:</label><input type="text" :id="'provemailsubject'+provider.providerid" class="provid-inputfield"/><br>
                            <label>Message:</label><br/>
                            <textarea :id="'provid-emailmsg'+provider.providerid" placeholder="Provider Message">

                            </textarea><br/>
                            <div class="btn-container">
                                <input type="button" class="btn btn-danger" value="Send Email" @click="SendProvEmail(provider,index)" id="sendprovid-emailbtn"/>
                                <input type="button" class="btn btn-secondary" value="Close Email" @click="CloseProvEmail(provider.providerid)" id="closeprovid-emailbtn"/>
                                <input type="hidden" id="sendprovider" value=""/>
                            
                            </div>
                        
                        </div>
                </div>
                

                    <current-provider-bio :provider="provider"></current-provider-bio>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import genders from '@/data/genders';
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
import PatientNurseBio from '../nurses/PatientNurseBio';
import { isNpiExist, register } from '@/api/userApi';
import { post } from '@/store/modules/fsm/index';
import {
    RequestRegistration,
    RegistrationSuccess,
    RegistrationFailure,
    Continue
} from '@/store/modules/fsm/messages';
import { restElement } from "@babel/types";
import { getContacts } from "@/api/userApi";

export default {
    name: "PatientNurses",
    data() {
        return {
            genders,
            allProvs: null,               // List of providers already saved for patient
            npiSearch: "",                // Primary physician search textfield value
            searchedNpis: null,           // List of physicians retrieved via npiSearch
            searchedAddresses: null,      // List of addresses associated with chosen physician
            editedProv: null,             // Provider that is being edited
            textingProv: null,
            txtMsg: "",
            txtPhone:"",
            addedProv: null,              // Provider that new account is being made for
            requiredAr:[],                //Arry that handles the required fields
            npisAdded: [],                 // List of npis added for group
            newGroupProvs: [],
            newGroupEmails:[],
            grouplist:[],
            groupNumber:[],                //List of Phone numbers 
           // patientContacts:null,            //patient contats
            // npi: "",                      // NPI of chosen physician
            // npiAddress: "",               // Address of chosen physician
            // npiPhone: "",                 // Phone number of chosen physician
            // npiFax: "",                   // Fax number of chosen physician
        }
    },
    components: {
        'current-provider-bio': PatientNurseBio,
    },
    async mounted() {
        this.loadProviders()
        console.log(this.allProvs)
       //this.addProviders();
       
     
    },
    computed: {
        ...mapGetters("login", {
            allData: "getAllData",
        }),
        patient: function () {
            return this.allData.patient;
        },
        manager: function () {
            return this.allData.manager;
        },
        relationships: function() { 
            return this.allData.relationDescriptions 
        }
    },
    methods: {
        showCreateAccount(prov) {
            isNpiExist(prov.npinumber).then((exist) => {
                if (exist) {
                    alert("An account with this NPI number already exists.")
                    this.addedProv = null
                }
                else {
                    this.addedProv = prov
                }
            })
        },
        createAccount() {
            let formData = new FormData(document.getElementById('accform' + this.patient.id))

            let loader = this.$loading.show({}, {
                after: this.$createElement('div', {}, ['Registering your information...'])
            });

            let form = {
                isLoggedIn: true,
                admin: true,
                npi: formData.get('newaccnpi'),
                externid: formData.get('newaccextern'),
                first: formData.get('newaccfirstname'),
                middle: '',
                last: formData.get('newacclastname'),
                login: formData.get('newaccusername'),
                password: formData.get('newaccpass'),
                password2: formData.get('newaccpass2'),
                enrollmentId: null,
                dob: formData.get('newaccdob'),
                email: formData.get('newaccemail'),
                ssnHead: '',
                ssnMiddle: '',
                ssnTail: '',
                gender: 1,                                 //   formData.get('newaccgender'), fix for select input
                suffix: null,
                title: null,                             
                addr: formData.get('newaccaddr'),
                city: '',
                state: '',
                zip: null,
                cell: formData.get('newacccell'),
                work: formData.get('newacctel'),
                home: null,
                ssn: ''
            }

            post({ message: RequestRegistration })
                .then(() => {
                    return register(form);
                })
                .then((username) => {
                    if (form.isLoggedIn)
                        alert(`Registration success. The username is: "${username}". Please find the verification code in the submitted email`);
                    else
                        alert(`Registration success. The username is: "${username}". Please find the verification code in the submitted email.`);
                    //TODO: redirect to verification page instead
                    post({ message: RegistrationSuccess });
                    this.closeNewProv()
                })
                .catch((err) => {
                    post({ message: RegistrationFailure });
                    alert('Registration failure: ' + err);
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },
        ShowSubNav(index){
            
            if($("#subnav"+index).css("display")=="flex")
            {
                $("#subnav"+index).css("display","none");
            }
            else{
                $("#subnav"+index).css("display","flex");
            }
            
        },
        showNurseForm() {
            if($("#nurseform").css("display")=="block")
            {
                $("#nurseform").slideUp("slow");
            }
            else{
                //close Provider Group
                $("#nurseform").slideDown("slow");
               
                
            }
        },
        CloseGroupEmailMsg()
        {
            $(".groupemailcecanvas").slideUp("fast");
        },
        CloseGroupConferenceCall()
        {
            $(".smsconferencecanvas").slideUp("fast");
        },
        
        SendGroupEmail(index)
        {
            let tempar ="";
             console.log("clicked");
            $("#accordionbottom"+index).find(".providminicard").each(function(){
                console.log("..looping through the mini cards");
               if($(this).find("#grprovemail").html() !="")
               {
                //psh into the array
                tempar +=$(this).find("#grprovemail").html()+",";
               
               }
               else{
                console.log("didn't record"+$(this).find("#grprovemail").html());
               }
               //lets show case the sms conference canvas
              
            }); 
            $(".groupemailcecanvas").css("display","block");
                $("#conferenceEmail").val(tempar);
                //now close the sub nave
                $("#subnav"+index).css("display","none");
        },
        async SendGroupEmailMsg(){
            let content = {
                Provider: {
                    API_Meth: "SendProviderEmail",
                    toemail:$("#conferenceEmail").val(),
                    message:$("#emailconferencebox").val(),
                    provider:this.manager.name,
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.message=="EmailSent")
                {
                    alert("Emails successfully sent to group "+$("#gpname").html()+" members!");
                    //now close SMS Canvas
                    $(".groupemailcecanvas").css("display","none");
                   // this.groupNumber = res.data.group;
                   // this.grouplist = res.data.group.providerslist;
                    
                   
                }
            });
        },
        GroupConferenceCall(index)
        {
            
            let tempar ="";
             console.log("clicked");
            $("#accordionbottom"+index).find(".providminicard").each(function(){
                console.log("..looping through the mini cards");
               if($(this).find("#grpphn").html() !="")
               {
                //psh into the array
                tempar +=$(this).find("#grpphn").html()+",";
               
               }
               else{
                console.log("didn't record"+$(this).find("#grpphn").html());
               }
               //lets show case the sms conference canvas
              
            }); 
            //hide the single text btn
           // $("#sbmttxtconfbtn").css("display","none");
            $(".smsconferencecanvas").css("display","block");
                $("#smsconferencephone").val(tempar);
            let msg ="Please Join The Park Avenue Concierge  Medicine Conference Call. Please be patient as the Conference Call will begin once other participatants join the call. Call the following number: 18556730319";
         $("#smsconferencebox").val(msg);
         // $(this).closest(".subnavcontainer").css("display","none");
                //now close the sub nave
                $("#subnav"+index).css("display","none");
                $("#sbmttxtconfbtn").css("display","none");
                $("#confcallbtn").css("display","inline-block");
        },
        async SendGroupConferenceCall(){
            let content = {
                Twilio: {
                    API_Meth: "SendConferenceText",
                    conferencenumbers:$("#smsconferencephone").val(),
                    conferencemessage:$("#smsconferencebox").val(),
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.TwilioStatus=="successful")
                {
                    alert("Conference Call successfully sent to group "+$("#gpname").html()+" members!");
                    //now close SMS Canvas
                    $("#confcallbtn").css("display","none");
                    $(".smsconferencecanvas").css("display","none");
                   // this.groupNumber = res.data.group;
                   // this.grouplist = res.data.group.providerslist;
                    
                   
                }
            });
        },
        async SaveSettings(event)
        {
            //check to see if the required settings has a value
            if($("#checkWhen").val() !="selected" && $("#notifyexpirationdt").val() !="selected" && $("#notifytype").val() !="selected" && $("#nursecomfeat").val() !="selected")
            {
                alert("go and do work");
                let freq = $("#checkWhen").val();
                let notifytype =$("#notifytype").val();
                let  notifyexpdt = $("#notifyexpirationdt").val();
                let nursecomfeatures = $("#nursecomfeat").val();
                //now lets send over values to be saved on the serv er
                let content = {
                ManageNurseList: {
                    API_Meth: "SendNurseSettings",
                    checklicenefreq:freq,
                    notifyexpdt :notifyexpdt,
                    Communicationtypes:nursecomfeatures,
                    notifytypes: notifytype,
                    accountnumber:"45000"
                    }
                 }
                await axios
                .post(CURR_API + "/tswebhook.php",content,{
                    headers: { "Content-Type": "application/json;"},
                })
                .then((res) => {
                    console.log(res);
                    if(res.data.message=="Settings Saved")
                    {
                        alert("Nurse Settings saved successfully");
                        //now close SMS Canvas
                       
                        
                    
                    }
                    else{
                        console.log(res.data);
                    }
                });
            }
            else{
                alert("Please ensure you've selected a value associated with the appropriate required fields");
            }
        },
        CancelSettings(event)
        {
            $(".nurseSettingSec").slideUp("slow");
        },
        CloseSaveSettings(event)
        {

        },
        CloseaddNurse(event)
        {
            event.preventDefault();
            $("#nurseform").slideUp("slow");
        },
        async addNurse(event){
            event.preventDefault();
            let reqar =[];
            let fname =$("#nursefname").val();
            let lastname = $("#nurselname").val();
            let accountnumber =  $("#nraccount").val();
            let licensenumber = $("#nrlicense").val();
            let jurisdiction = $("#nrstate").val();
            let nursetype = $("#nursetype").val();
            let last4social = $("#nrsocial").val();
            let email = $("#nurseemail").val();
            let dob = $("#nrdob").val();
           // let valfields= this.validateFields();
           let msg="";
            if(fname.length <1)
            {

                reqar.push("firstname");
                $(".order-grid").find("#nursefname").css("border-color","#ff0000");
            }
            else{
                $(".order-grid").find("#nursefname").css("border-color","#000000");
            }
             if(lastname =="" || lastname.length <1)
            {
               
                reqar.push("lastname");
                $("#nurselname").css("border-color","#ff0000");
            } 
            else{
                $("#nurselname").css("border-color","#000000");
            }
            if(accountnumber =="" || accountnumber.length <1)
            {
                
                reqar.push("accountnumber");
                $("#nraccount").css("border-color","#ff0000");
            }
            else{
                $("#nraccount").css("border-color","#000000");
            }
             if(licensenumber =="" || licensenumber.length <1)
            {
               
                reqar.push("licensenumber");
                $("#nrlicense").css("border-color","#ff0000");
            }
            else{
                $("#nrlicense").css("border-color","#000000");
            }
             if(jurisdiction =="" || jurisdiction.length <1)
            {
            reqar.push("jurisdiction");
            $("#nrstate").css("border-color","#ff0000");
            }
            else{
                $("#nrstate").css("border-color","#000000");
            }
             if(nursetype =="selected")
            {
            reqar.push("nurstype");
            $("#nursetype").css("border-color","#ff0000");
            
            }
            else{
                $("#nursetype").css("border-color","#000000");
            }
             if(last4social =="" || last4social.length <1)
            {
           
            reqar.push("last4social");
            $("#nrsocial").css("border-color","#ff0000");
            }
            else{
                $("#nrsocial").css("border-color","#000000");
            }
            if(email =="" || email.length <1)
            {
           
            reqar.push("email");
            $("#nurseemail").css("border-color","#ff0000");
            }
            else{
                $("#nurseemail").css("border-color","#000000");
            }
            if(dob =="" || dob.length <1)
            {
           
            reqar.push("dob");
            $("#nrdob").css("border-color","#ff0000");
            }
            else{
                $("#nrdob").css("border-color","#000000");
            }
            console.log(reqar);
            if(reqar.length >0)
            {
               
                msg="Not Valid";
                let alertmsg="";
                  alertmsg +="<div id='msgbox'>";
                for(var i=0; i<reqar.length;i++)
                {
                  
                    alertmsg +=reqar[i]+",";
                }
                alertmsg +=" fields are required.";
                alertmsg +="</div>";
                $(".msgbx").html('');
                $(".msgbx").append(alertmsg);
                $(".msgbx").slideDown("slow");
               // return msg;
            }
            else{
                
                msg="Valid";
                $(".msgbx").html('');
                $(".msgbx").slideUp("slow");
               // return;
            }
           if(msg=="Valid")
           {

              //disable the button 
              $("#addnursebtn").attr("disabled","disabled");
                let content = {
                    ManageNurseList: {
                        API_Meth: "Add_Nurse",
                        ncsid: $("#nrnsbid").val(),
                        jurisdiction: $("#nrstate").val() ,
                        subactioncode:"A",//required
                        licensnum: $("#nrlicense").val(),
                        ltype: $("#nursetype").val(),
                        email: $("#nurseemail").val(),
                        primephone: $("#primephone").val(),
                        secondaryphone: $("#secphone").val(),
                        address1: $("#nraddress").val(),//req
                        address2: "",
                        city: $("#nrcity").val(),//req
                        state: $("#nrstate").val(),//req
                        zip: $("#nrzip").val(),//req
                        lastfourssn: $("#nrsocial").val(),//req
                        bdayear: $("#nrdob").val(),//req
                        hospitalpracsetting: "21",//req
                        hostpracsettingother:"",
                        notficationenabled: "Y" ,//req
                        reminderenabled: "Y",//req
                        locationlist: "",
                        recid: "" ,
                        accountnumber: $("#nraccount").val(),
                        firstname:$("nursefname").val(),
                        lastname:$("#nurselname").val(),
                    
                    
                    }
                }
                await axios
                .post(CURR_API + "/tswebhook.php",content,{
                    headers: { "Content-Type": "application/json;"},
                })
                .then((res) => {
                    console.log(res);
                    let jdata = res;
                    console.log(jdata);
                    //enable the bottun again 
                    $("#addnursebtn").removeAttr("disabled","disabled");
                    if(jdata.data.status=="Nurse Added")
                    {
                        alert("Nurse" +" "+$("#nursefname").val() +" "+$("#nurselname").val()+" Successfully Added");
                        //now close SMS Canvas
                    
                        let ask = confirm("Nurse has been verified, would you like to add them to your account?");
                        if(ask==true)
                        {
                            //lets now add them to our internal database 
                                    
                        this.AddInternalNurse();
                        //now load list of nurse
                        this.loadProviders();
                        //clear out the form
                        $("#nursefname").val();
                        $("#nurselname").val('');
                        $("#nraccount").val('');
                        $("#nrlicense").val('');
                        $("#nrstate").val('');
                        $("#nursetype").val('');
                        $("#nrsocial").val('');
                        $("#nurseemail").val('');
                        $("#nrdob").val('');
                        $("#nraddress").val('');
                        $("#nrcity").val('');
                        $("#nrzip").val('');
                        $("#nraccount").val('');

                        }
                    
                    }
                    else if(jdata.data.status=="Nurse Not Added")
                    {
                        console.log("Issue");
                        console.log(jdata.data.errors[0]);
                        alert("Nurse wasn't added to the system. Please check data and try again");
                    }
                    else if(jdata.data.status=="No Server Response")
                    {
                        alert("Nursyses Not Responding Code 300 - Please try again in 2 minutes");
                    }
                });
            }
            else{
                alert("Missing Required Fields. Please reveiw and try again.");
            }
        },
        validateFields()
           {
            console.log(this.requiredAr);
            console.log(this.requiredAr.length);
               let reqar =[];
               let obj ={};
               if(this.requiredAr.length <1)
               {

                 reqar.push(firstname);
                 $("nursefname").css("border-color","#ff0000");
               }else if(lastname =="" || lastname.length <1)
               {
                 reqar.push("lastname");
                 $("#nurselname").css("border-color","#ff0000");
               }else if(accountnumber =="" || accountnumnber.length <1)
               {
                 reqar.push("accountnumber");
                 $("#nraccount").css("border-color","#ff0000");
               }else if(licensenumber =="" || licensenumber.length <1)
               {
                 reqar.push(licensenumber);
                 $("#nrlicense").css("border-color","#ff0000");
               }else if(jurisdiction =="" || jurisdiction.length <1)
               {
                reqar.push(jurisdiction);
                $("#nrstate").css("border-color","#ff0000");
               }else if(nursetype =="" || nursetype.length <1)
               {
                reqar.push(nurstype);
                $("#nurselname").css("border-color","#ff0000");
                $("#nursetype")
               }else if(last4social =="" || last4social.length <1)
               {
                reqar.push(last4social);
                $("#nrsocial").css("border-color","#ff0000");
               }

                if(reqar.length >0)
                {
                    let msg ="";
                    msg="Not Valid";
                    return msg;
                }
                else{
                    let msg="";
                    msg="Valid";
                    return;
                }
           },
        async AddInternalNurse(){
            let content = {
                ManageNurseList: {
                    API_Meth: "InternalAddNurse",
                    ncsid: $("#nrnsbid").val(),
                    jurisdiction: $("#nrstate").val() ,
                    subactioncode:"A",//required
                    licensnum: $("#nrlicense").val(),
                    ltype: $("#nursetype").val(),
                    email: $("#nurseemail").val(),
                    primearyphone:$("#primephone").val(),
                    secondaryphone: $("#secphone").val(),
                    address1: $("#nraddress").val(),//req
                    address2: "",
                    city: $("#nrcity").val(),//req
                    state: $("#nrstate").val(),//req
                    zip: $("#nrzip").val(),//req
                    lastfourssn: $("#nrsocial").val(),//req
                    bdayear: $("#nrdob").val(),//req
                    hospitalpracsetting: "21",//req
                    hostpracsettingother:"",
                    notficationenabled: "Y" ,//req
                    reminderenabled: "Y",//req
                    locationlist: "",
                    recid: "" ,
                    accountnumber: $("#nraccount").val(),
                    firstname:$("#nursefname").val(),
                    lastname:$("#nurselname").val(),
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.message=="Inserted")
                {
                    alert("Nurse Added to the system successfully!");
                    //now close SMS Canvas
                   
                   
                   
                }else if(res.data.message=="Record Exist")
                {
                    alert($("#nursefname").val()+" "+$("#nurselname").val()+", already Exist in our System. You may want to edit or update Nurses Information from the Nurses section.");
                }
                else
                {
                    alert(res.message);
                    console.log("Nurses not added successfully");
                }
            });
        },
        async SendGroupTextMsg(){
            let content = {
                Twilio: {
                    API_Meth: "SendText",
                    smsnumber:$("#smsconferencephone").val(),
                    smsmessage:$("#smsconferencebox").val(),
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.TwilioStatus=="successful")
                {
                    alert("Text successfully sent to group "+$("#gpname").html()+" members!");
                    //now close SMS Canvas
                    $(".smsconferencecanvas").css("display","none");
                   // this.groupNumber = res.data.group;
                   // this.grouplist = res.data.group.providerslist;
                    
                   
                }
            });
        },
         SendGroupText(index)
        {
             let tempar ="";
            
            $("#accordionbottom"+index).find(".providminicard").each(function(){
                console.log("..looping through the mini cards");
               if($(this).find("#grpphn").html() !="")
               {
                //psh into the array
                tempar +=$(this).find("#grpphn").html()+",";
               
               }
               else{
                console.log("didn't record"+$(this).find("#grpphn").html());
               }
               //lets show case the sms conference canvas
              
            }); 
            $(".smsconferencecanvas").css("display","block");
                $("#smsconferencephone").val(tempar);
                //now close the sub nave
                $("#subnav"+index).css("display","none");
                $("#smsform").find("#smsconferencebox").val('');
                $("#confcallbtn").css("display","none");
                $("#sbmttxtconfbtn").css("display","inline-block");
               
        },
        ShowGroupList(index){
            
           if($("#accordionbottom"+index).css("display")=="block")
           {
              $("#accordionbottom"+index).slideUp("slow");
           }else{
            //close the Add Group Section 
           
             $("#accordionbottom"+index).slideDown("slow");
           }
        },
        async DeleteGroup(index)
        {
            //lets get the group name 
            let groupname = $("#deletegrp"+index).closest(".card").find("#gpname").html();
            console.log(groupname);
            let content = {
                Provider: {
                    API_Meth: "DeleteProviderGroup",
                    accountnumber:this.allData.patient.externId,
                    groupowner:this.manager.name,
                    groupname:groupname
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                if(res.data.status=="200" && res.data.message=="Deleted")
                {
                    alert($("#deletegrp"+index).closest(".card").find("#gpname").html()+" has been successfully deleted!");
                }
            });
        },
        VerifyAllNurses(){
            
            this.BatchVerify();
            $("#verifybtn").attr("disabled","disabled");
                   
        },
        async BatchVerify(){
           
           
            let content = {
                NursyInfo: {
                    API_Meth: "LookupBatchNursesInfo",
                    accountnumber:"45000",
                   
                }
            }
            await axios
            .post(CURR_API + "/tswebhook.php",content,{
                headers: { "Content-Type": "application/json;"},
            })
            .then((res) => {
                console.log(res);
                $("#verifybtn").removeAttr("disabled");
                alert("Verifying Nurses Completed!");
                if(res.data.length >0)
                {
                   
                   for(var i=0; i < res.data.length;i++)
                   {
                    var t=0;
                        $(".result-list").find("li").each(function(){
                            t++;
                            console.log("looping"+t);
                            console.log($(".result-list").find(".header3").html());
                            if( res.data[i].activeStatus=="YES")
                            {
                                $("#vstatus2"+res.data[i].licensenum).css("display","block");
                                $("#vstatus"+res.data[i].licensenum).css("display","none");
                            }
                            if(res.data[i].activeStatus !="YES")
                            {
                                $("#vstatus"+res.data[i].licensenum).css("display","block");
                                $("#vstatus2"+res.data[i].licensenum).css("display","none");
                            }
                        });
                   }
                    $(".order-grid").find(".listGroupSec").css("display","block");//("slow");
                   
                }
            });
        
        },
        async loadProviders() {
            let content = {
                NursyInfo: {
                    API_Meth: "GetPatientNurse",
                    accountnumber:this.patient.externId2,
                    patientnumber:this.patient.externId
                }
            }
            await axios
                .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    console.log(res);
                    if (res.data) {
                        this.allProvs = res.data//.nurseInfo
                    } else {
                        this.allProvs = null;
                    }
                });
        },
       /* addProviders()
        {
            let data = {};
            
           
            getContacts().then((c) => {
                console.log(c);
               /* for(var i=0; i< c;i++)
               {
                data.provider =[
                "{'firstname':"+c[i]['firstName'],
                 "lastname":+c[i]["lastName"],
                 "npi":c[i]["license"],
                "lastname":c[i]]["npinumber"],
                "address":c[i]["address1"],

                ];
               }*/
           /* this.patientContacts =c;
        console.log(this.patientContacts);
        console.log(this.relationships);
            })
        },*/
        
        async SendProvEmail(provider,index)
        {
            
            let mcontent = {
               Provider:{
                 API_Meth:"SendProviderEmail",
                 provider:provider.firstname+" "+provider.lastname,
                 subject:$("#provemailsubject"+provider.providerid).val(),
                 message:$("#provid-emailmsg"+provider.providerid).val(),
                 toemail:$("#providetomail"+provider.providerid).val()
               }

            }
            await axios
            .post(CURR_API +"/tswebhook.php",mcontent,{
                headers:{ "Content-Type": "application/json;" },
            })
            .then((res) =>{
                console.log(res)
                console.log(res.data);
                console.log(res.data.message);
                
                if(res.data.message && res.data.message=="EmailSent")
                {
                    alert("Email Successfully Sent to Proviver"+" "+provider.firstname+ " "+provider.lastname);
                    //now hide the UI
                    $("#emailcanvas"+index).css("display","none");
                }
            });
        },
        CloseProvEmail(pid)
        {
            $("#emailcanvas"+pid).css("display","none");
        },
        async showResults() {
            let content = {
                "methname": "GetAllInfo",
                "primphysician": this.npiSearch
            }
            // this.showPreloader()
            await axios.post(CURR_API + "/NPILookup.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    console.log(res)
                    if (res.data.results && res.data.results == "No Results Found") {
                        this.searchedNpis = null
                    }
                    else
                        this.searchedNpis = res.data
                })
            // this.stopPreloader()
        },
        async removeProvider(licensenumber) {
            if (confirm("Are you sure you want to remove this nurse from your account?")) {
                let content = {
                    ManageNurseList: {
                        API_Meth: "DeleteNurse",
                        licensnum: $("#desktopLicense"+licensenumber).html(),
                        jurisdiction:  $("#state"+licensenumber).html(),
                        ltype: $("#ltype"+licensenumber).html() ,
                        subactioncode:"R",//required
                    }
                }
                await axios
                    .post(CURR_API + "/tswebhook.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        console.log(res);
                        if (res.data.status == "Nurse Added") {
                            //call function to remove nursefrom our internal database
                            this.deleteInternalNurse(licensenumber);
                            //this.loadProviders();
                        } else {
                            alert("Error with provider deletion.")
                        }
                    });
            }
        },
        async dischargeProvider(accountnumber,patientnumber,nurseid,firstname,lastname){
           let ardata = nurseid+"-"+firstname+" "+lastname;
           let nurseInfo = [];
            nurseInfo.push(ardata);
            let content = {
                NursyInfo: {
                        API_Meth:"DischargeNurseFromPatient",
                        patientid: patientnumber,
                        accountnumber:accountnumber,
                        nurseInfo:nurseInfo,
                        nurseid:nurseid
                    }
                }
                await axios
                    .post(CURR_API + "/tswebhook.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        console.log(res);
                        if(res.data.message=="Nurse Discharged Successfully")
                        {
                        //lets check to see if they were assigned and/or discharged 
                           alert("Nurse Dischaged Successfully");
                           loadProviders();
                           
                            

                        }
                        
                        else{
                            alert("Nurse Not Discharged Successfully,Please try again");
                        }
                    })
                    .catch((err) => {
                    console.log(err);
                    })
                
        
            
        },
        async callProvider(provider) {
            if (!this.manager.phone1 && !this.manager.phone2) {
                alert("You have no phone number associated with your account. Please visit your profile page and set one.")
            }
            else {
                let content = {
                    "Twilio": {
                        "API_Meth": "SendPhoneCalls",
                        "from": this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
                        "callnumber": provider.primaryphone
                    }
                }
                await axios
                    .post(CURR_API + "/tswebhook.php", content, {
                        headers: { "Content-Type": "application/json;" },
                    })
                    .then((res) => {
                        console.log(res);
                        if (res.data.status != "") {
                            alert("Connecting call...")
                        }
                        else {
                            alert("Error connecting call.")
                        }
                    });
            }
        },
        async sendText(id) {
            
            let content = {
                "Twilio": {
                    "API_Meth": "SendText",
                    "smsnumber": $("#modaltext"+id).val(),
                    "smsmessage": $("#modalmsg"+id).val()// this.txtMsg
                }
            }
            console.log(content)
            await axios
                .post(CURR_API + "/tswebhook.php", content, {
                    headers: { "Content-Type": "application/json;" },
                })
                .then((res) => {
                    console.log(res);
                    if (res.data.status != "") {
                        alert("Text sent");
                        this.closeText();
                    }
                    else {
                        alert("Error sending text");
                    }
                });
        },
        showTextProv(provider) {
            this.textingProv = provider;
            console.log(this.textingProv);
            $("#send-text-modal-" + this.patient.id).css("display", "flex");
        },
        showEmailModule(event,index,provider){
           
            console.log(event.target.attributes.class);
            console.log(index);
            console.log(provider);
            console.log($(event.target.attributes.class).closest(".emailcanvas").attr("class"));
            let subject ="You have a message from"+" "+provider.firstname+" "+provider.lastname+", PLease login into the Pacmny EMR Portal to view message.";
            $("#provemailsubject"+provider.providerid).val(subject);
            let message="Dr. "+provider.firstname+",please login to view your message from Park Avenue Concerige Medicine EMR Portal.";
            $("#provid-emailmsg"+provider.providerid).val(message);
            console.log($(".emailcanvas").attr("class"));
           
            $("#emailcanvas"+provider.providerid).css("display","block");
            //now lets bind the providers email address to the email input field 
            console.log(provider.email);
            $("#providetomail"+provider.providerid).val(provider.email);
          
        },
        closeText() {
            this.textingProv = null
            this.txtMsg = "Please visit the PACMNY application."
            $("#send-text-modal-" + this.patient.id).css("display", "none")
        },
        showAddProv() {
           
           if($(".nurseSettingSec").css("display")=="block")
           {
            $(".nurseSettingSec").slideUp("slow");
            $(".result-list").slideDown("slow");
           }
           else{
            if($("#nurseform").css("display")=="block")
            {
                $("#nurseform").slideUp("slow");
            }
             $(".result-list").slideUp("slow");
             $(".nurseSettingSec").slideDown("slow");
             //hide nurses cards
            
            
           }
           
        },
        showEditProv(prov) {
           //lets show the edit form and hide the card data
            console.log(prov);
            $("#nurseform"+prov).closest(".nurse-edit").css("display","block");
           $("#nurseform"+prov).slideDown("slow");
            $("#nursecard"+prov).slideUp("slow");
        },
        showMod(index) {
            if ($("#modifier-dropdown" + index).css('display') == 'none')
                $("#modifier-dropdown" + index).css("display", "flex");
            else
                $("#modifier-dropdown" + index).css("display", "none");
        },
        selectNpi(npi) {
            document.querySelector("#phynpi").value = npi.npinumber
            let name = npi.name.trim().split(" ")
            document.querySelector("#phyfirstname").value = name[0]
            document.querySelector("#phylastname").value = name[name.length - 1]

            this.searchedNpis = null
            this.searchedAddresses = npi.addresses
        },
        async saveProv() {
            let callnumexist="";
            let isemailValid="";
            if($("#phytel").val() !="" || $("#phycell").val() !="")
            {
                callnumexist="true";
            }
            else{
                callnumexist="false";
            }
            //valdate email 
            let re = /^\w+([-+.'][^\s]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

            let emailFormat = re.test($("#phyemail").val()); // This return result in Boolean type
            console.log(emailFormat);
            if (emailFormat) {
                isemailValid=true;
            }
            else{
                isemailValid=false;
            }
            if($("#phyfirstname").length !=0 && $("#phylastname").length !=0 && $("#phytel").length !=0 && $("#phyemail").length !=0 && isemailValid==true && callnumexist=="true")
            {
                let form = document.getElementById("provform" + this.patient.id)
            let modal = document.getElementById("provmodal" + this.patient.id)
            let content = {
                "Provider": {
                    "API_Meth": "AddProvider",
                    "provFname": form.elements["phyfirstname"].value,
                    "provLname": form.elements["phylastname"].value,
                    "provAddr1": form.elements["phyaddr"].value,
                    "provAddr2": "",
                    "provCity": "",
                    "provState": "",
                    "provZip": "",
                    "provTel": form.elements["phytel"].value,
                    "provCell": form.elements["phycell"].value,
                    "provFax": form.elements["phyfax"].value,
                    "npinumber": form.elements["phynpi"].value,
                    "pid": this.patient.externId,
                    "ordernumber": "999",
                    "status": "Active",
                    "provEmail": form.elements["phyemail"].value
                }
            }
            console.log(content)
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    console.log(res)
                    if (res.data.message && res.data.message == "Inserted") {
                        this.npiSearch = null
                        this.searchedNpis = null
                        this.searchedAddresses = null
                        this.loadProviders()

                        alert("Provider successfully added")
                        form.reset()
                        modal.style.display = "none"
                    }
                    else {
                        alert("Error with provider insertion. Try again or contact an administrator.")
                    }
                })
            }
            else{
                alert("Please ensure the form field requirements has been met. Please check your entries and try again.");
            }
           
        },
        async saveEditProv() {
            let form = document.getElementById("edit-prov-form-" + this.patient.id)
            let modal = document.getElementById("edit-prov-modal-" + this.patient.id)
            let content = {
                "Provider": {
                    "API_Meth": "UpdateProvider",
                    "providerid": this.editedProv.providerid,
                    "email": "",
                    "patientid": this.patient.externId,
                    "ordernumber": "",
                    "firstname": form.elements["phyfirstname"].value,
                    "lastname": form.elements["phylastname"].value,
                    "address1": form.elements["phyaddr"].value,
                    "address2": "",
                    "city": "",
                    "state": "",
                    "zip": "",
                    "phone": form.elements["phytel"].value,
                    "cell": form.elements["phycell"].value,
                    "email": form.elements["phyemail"].value,
                    "fax": form.elements["phyfax"].value,
                    "npinumber": form.elements["phynpi"].value,
                    "status": "Active"
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    console.log(res)
                    if (res.data.msg && res.data.msg == "Updated") {
                        this.loadProviders()
                        alert("Provider successfully edited")
                        this.editedProv = null
                        // form.style.display = "none"
                        // modal.style.display = "none"
                    }
                    else {
                        alert(res.data[1])
                    }
                })
        },
        selectAddr(addr) {
            document.querySelector("#phyaddr").value = addr.address ? addr.address : ""
            document.querySelector("#phytel").value = addr.tel ? addr.tel : ""
            document.querySelector("#phyfax").value = addr.fax ? addr.fax : ""
            this.searchedAddresses = null
        },
        closeProv() {
            let form = document.getElementById("provform" + this.patient.id)
            form.reset()
            this.npiSearch = null
            this.searchedAddresses = null
            this.searchedNpis = null
            let modal = document.getElementById("provmodal" + this.patient.id)
            modal.style.display = "none"
        },
        closeEditProv() {
            let form = document.getElementById("edit-prov-form-" + this.patient.id)
            form.reset()
            this.npiSearch = null
            this.searchedAddresses = null
            this.searchedNpis = null
            this.editedProv = null
            let modal = document.getElementById("edit-prov-modal-" + this.patient.id)
            modal.style.display = "none"
        },
        closeNewProv() {
            let form = document.getElementById("accform" + this.patient.id)
            form.reset()
            this.addedProv = null
        }
    }
}
</script>
<style scoped lang="scss">
.edit-prov-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}
.nurseform-btn{
    display:flex;
    align-items: space-evenly;
    
}
#nurseform{
    display:none;
}
#nurseform .msgbx{
    display:none;
    background-color: red;
color: #fff;
font-size: 18px;
padding: 10px;
margin-bottom: 10px;
word-break: break-word;
}
.top-title{
    text-align: center;
    color:#0060ff;
}
.new-prov-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: none;
    justify-content: center;
    align-items: center;
}

.new-acc-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}

.send-text-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}

.edit-prov-modal form {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
}

.new-acc-modal form {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
}

.new-prov-modal form {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
}

.inner-text-modal {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
    font-size: 14px;
}

.form-control {
    display: block;
    width: 100%;
    height: 40px;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: none;
}

.btn-group {
    display: flex;
    justify-content: flex-end;
}
.form-control.prvtxtMsgbox{
    border-style:solid;
    border-color:#000000;
    height:140px;
}
.btn-primary,
.btn-secondary {
    height: 40px;
    padding: 0 20px;
}

.header2 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #0060ff;
}

.title {
    margin-right: 20px;
}

.result-list {
    width: 700px;
}

.result-item {
    border: 1px solid lightgray;
    border-radius: 5px;
    margin: 2em auto 0;
    text-align: left;
}

.result-item:first-child {
    margin-top: 1.0em;
}

.header3 {
    text-align: center;
    color: #fff;
    font-size: 1.2em;
    padding: 5px 0;
    background-color: #007bff;
}

.capitalize {
    text-transform: capitalize;
}

.result-item-link {
    display: block;
    text-align: right;
    font-size: 0.85em;
}

ul {
    list-style-type: none;
    margin: 0 auto;
}
.providerGroup-listcard{
    display: flex;
justify-content: space-evenly;
border-style: dashed;
border-width: 1px;
width: 100%;
}

/*Keyon Add Provider CSS*/
#nurseform .form-container{
    display:flex;
    flex-direction:column;
    max-width:700px;
}
.form-container input[type=text]{
    margin-bottom:10px;
}
.form-container input[type=phone]{
    margin-bottom:10px;
}
.form-container input[type=email]{
    margin-bottom:10px;
}
.form-container input[type=date]{
    margin-bottom:10px;
}
#nursetype{
    margin-bottom:10px;
}
.provcardSec{
    display:none;
    align-items: center;
    position: relative;
    flex-direction: column;
}
.emailcanvas{
    display:none;
   

}

#cllprov{
    margin-left:20px;
}
#providetomail{
    margin-left:30px;
}
#provemailsubject{
    margin-left:30px;
}
#provid-emailmsg{
    margin-left: 30px;
    margin-top: -10px;
    margin-bottom: 10px;
    width: 400px;
    height: 100px;
}
#sendprovid-emailbtn{
    margin-left:30px;
}
.emailcanvas .container{
    box-shadow: 1px 1px 9px #5f5852;
    position:absolute;
    background-color:#ffffff;
    width: 855px;
    height:auto;// 710px;
    padding-bottom:20px;
    margin:0 auto;
    
}
.emailcanvas .btn-container{
    padding-bottom:30px;
}
.emailcanvas label{
    margin-bottom:20px;
}
#providetomail{
    margin-left:30px;
}
.emailcanvas ul{
    display:flex;
    margin-top:-64px;
}
.emailcanvas .emailli{
        list-style: none;
    margin-left: 20px;
}
.emailcanvas .emailblock{
    background-color:#aaabac;
    padding: 5px 5px;
    width: auto;
    height: auto;
    margin-left:12px;
    position: relative;
    top: 17px;
}
.emailcanvas .xout{
    background-color: white;
    cursor: pointer;
}
.mmailbox{
    background-color:#55555512;
    width:100%;
        position: relative;
    z-index: 3000000000;
    top: -35px;
}
.mmailbox #hiddenmail{
    display:none;
}
.emailcanvas .selectbox{
    margin-top:-10px;
}
.inputvalholder{
    display:none;
    justify-content: flex-start;
}
.listGroupSec{
    display:none;
}
 .listGroupSec .card .accordhead{
        display: flex;
    flex-direction: row-reverse;
    border-style: solid;
    border-width: 1px;
    border-color: #606565b0;
}
 .listGroupSec .card .caret{
    text-align: right;
    width: 100px;
}
.listGroupSec .card .grp-name{
    width: 100%;
    margin: 0 auto;
}
.listGroupSec .card .grp-name p{
    text-align: center;
}
.listGroupSec .accordionbottom{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    border-style: solid;
    border-width: 1px;
    border-color: #0433;
    display: flex;
}
.listGroupSec .providminicard{
    display: flex;
    flex-direction: row-reverse;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    flex-direction: row-reverse;
    padding: 11px;
    margin-bottom: 3px;

}
.listGroupSec #accord-caret{
    cursor:pointer;
}
.listGroupSec #accord-caret:hover{
    color:#4553;
}
.listGroupSec .groupcanvas .card{
    display:flex;
    flex-direction:column;
}
.listGroupSec .subnavcontainer{
    display: none;
    flex-direction: column;
    width: 248px;
    margin-left: -153px;
    border-style: ridge;
    padding: 11px;

}
.listGroupSec #elipse{
    cursor:pointer;
}
.listGroupSec .closecanvas{
    display:none;
}
.listGroupSec .creategrpcanvas{
    display:none;
}
.listGroupSec .groupcanvas{
    display: none;
}
.accordionbottom{
    display:none;
}
.smsconferencecanvas{
    display: none;
}
.listGroupSec .accordionbottom{
    display:none;
}
.groupemailcecanvas{
    display:none;
}
#sbmttxtconfbtn{
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 20px;
}
#smsconferencebox{
    width: 650px;
    height: 220px;
}
#smsconferencephone{
    width: 425px;
height: 45px;
margin-bottom: 20px;
margin-top: 20px;
margin-left: 20px;
}
.smsconferencecanvas .container{
    padding: 10px;
display: flex;
text-align: center;
}
.groupemailcecanvas .container{
    padding:10px 100px;
    display: flex;
    text-align: center;
}
#emailform{
    border-style:solid;
    border-width:1px;
    border-color:#003330;
}
#conferenceEmail{
    width: 425px;
height: 45px;
margin-bottom: 20px;
margin-top: 20px;
margin-left: 20px;
}
#emailconferencebox{
    width: 650px;
    height: 220px
}
#sbmtemailconfbtn{
    margin-top:15px;
    margin-bottom:15px;
}
.smsconferencecanvas #closeconfcallbtn{
    margin-left:15px;
}
#groupemailcancelbtn{
    margin-left:15px;
}
.prvtxtbox{
    height:42px;
}
.status-active{
    display:none;
    background-color:#70a50d;
    color:#ffffff;
    font-size:17px;
}
.status-nonactive{
    display:none;
    background-color:#f12f4f;
    color:#ffffff;
    font-size:17px;
}
.nurseSettingSec{
    width:100%;
    height:auto;
    display:none;
}
.nurseSettingSec form{
    display: flex;

align-items: left;
flex-direction: column;
}
.nurseSettingSec .horizontal{
    display: flex;
flex-flow: row;
align-items: center;
justify-content: start;
}
.nurseSettingSec .vertical{
    display:flex;
    flex-direction:column;
}
.h-vertical{
    display: flex;
flex-direction: column;
}
.setting-container{
    max-width:700px;
}
#savesettingbtn{
    margin-right:20px;
}
.nurseSettingSec select{
    margin-left:20px;
    margin-bottom:20px;
    width:265px;
    border-radius:6px;
    height:32.5px;
}

/*End Keyon Provider CSS*/
@media only screen and (min-width:1024px)
{
   
}
@media only screen and (min-width: 1024px)
{
    #provid-emailmsg{
        width:400px;
    }
    .result-list .emailcanvas .container{
        width:655px;
    }
    .groupemailcecanvas .container{
        padding:10px 100px;
    }
    #conferenceEmail{
        margin:20px;
    }
    #emailconferencebox{
        width:100%;
    }
    .icon .desktopTel{
        display:flex;
    }
    .icon .mobileTel{
        display:none;
    }
    .emailcanvas .container textarea{
        width:485px;
        height:175px;
    }
    #smsconferencebox{
        width:650px;
    }
    #smsconferencephone{
        width:425px;
        margin:20px;
    }
}
@media only screen and (max-width: 768px) {
    .result-list {
        width: 100%;
    }
}
@media only screen and (min-width:360px)
{
    #smsconferencephone{
        width:100%;
        margin:0px;
    }
    #smsconferencebox{
        width:100%;
    }
    .d-option{
        display:none;
    }
    .icon .desktopTel{
        display:none;
    }
    .icon .mobileTel{
        display:flex;
    }
    #provid-emailmsg{
        width:280px;
    }
    .emailcanvas .container{
        width:340px;
    }
    .groupemailcecanvas .container{
        padding:0px;
    }
    #conferenceEmail{
        margin:10px 0px;
        width:100%;
    }
    #emailconferencebox{
        width:100%;
    }
}
</style>